import { render, staticRenderFns } from "./UnitPriceErrorFormatter.vue?vue&type=template&id=6806e830&functional=true"
import script from "./UnitPriceErrorFormatter.vue?vue&type=script&lang=js"
export * from "./UnitPriceErrorFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports